export default __webpack_public_path__ + "static/media/crypto.9d0f873b.png";